import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import connect from 'components/lib/connect';

import NavigateTo from 'actions/current_location/navigate_to';
import TeamEditor from 'models/location/team_editor';
import Button, { ButtonTypes } from 'components/common/button';
import { H1 } from 'components/common/headers';
import InsetContainer from 'components/common/containers/inset_container';
import StackContainer from 'components/common/containers/stack_container';
import SearchInput from 'components/common/search_input';
import TeamsList from 'components/admin/users/teams_list';

const leftColumnWidth = 320;
const TeamsWrapper = styled(InsetContainer)`
  border-right: 1px solid ${p => p.theme.colors.gray300};
  min-width: ${leftColumnWidth}px;
  overflow-y: auto;
  width: ${leftColumnWidth}px;
`;

const ButtonContainer = styled(StackContainer)`
  width: 140px;
  align-items: flex-start;
  flex-direction: row;
`;

const UsersHeader = styled(H1)`
  color: ${p => p.theme.colors.black};
`;

class TeamsSection extends React.Component {
  constructor(props) {
    super(props);
    this.handleChangeTextFilter = this.handleChangeTextFilter.bind(this);
    this.handleClearTextFilter = this.handleClearTextFilter.bind(this);
    this.state = { textFilter: '' };
  }

  handleChangeTextFilter(evt) {
    this.setState({ textFilter: evt.target.value });
  }

  handleClearTextFilter() {
    this.setState({ textFilter: '' });
  }

  render() {
    return (
      <TeamsWrapper inset="large">
        <UsersHeader stack="large">Users</UsersHeader>
        <ButtonContainer stack="large" inset="none">
          <Button buttonType={ButtonTypes.SECONDARY} data-aid="createTeamButton" onClick={this.props.onCreateTeamClick}>
            Create team
          </Button>
        </ButtonContainer>
        <StackContainer inset="none" stack="large">
          <SearchInput
            className="teamsList-searchInput"
            initialValue={this.state.textFilter}
            onChange={this.handleChangeTextFilter}
            onClearText={this.handleClearTextFilter}
            placeholder="Search teams"
          />
        </StackContainer>
        <TeamsList textFilter={this.state.textFilter} />
      </TeamsWrapper>
    );
  }
}

export { TeamsSection };

TeamsSection.propTypes = {
  onCreateTeamClick: PropTypes.func,
};

function mapExecuteToProps(executeAction) {
  return {
    onCreateTeamClick: () => executeAction(NavigateTo, TeamEditor.create()),
  };
}

const TeamsSectionContainer = connect(null, mapExecuteToProps)(TeamsSection);
export default TeamsSectionContainer;



// WEBPACK FOOTER //
// ./src/scripts/presentation/components/admin/users/teams_section.jsx